import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/form-components/input'
import FormGroup from 'components/form-components/form-group'
import { Label } from 'components/styled/typography'


/**
 * Render full input with all boilerplate required by react-form and react-redux-form
 */
function FormInput(props) {
  return (
    <FormGroup model={props.model}>
      {props.label && <Label color="grey90">{props.label}</Label>}
      <Input {...props} />
    </FormGroup>
  )
}

FormInput.propTypes = {
  model: PropTypes.string.isRequired,
}

export default FormInput
